import { render, staticRenderFns } from "./GrandExchange.vue?vue&type=template&id=50eaf8ec&scoped=true&"
import script from "./GrandExchange.vue?vue&type=script&lang=js&"
export * from "./GrandExchange.vue?vue&type=script&lang=js&"
import style0 from "./GrandExchange.vue?vue&type=style&index=0&id=50eaf8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eaf8ec",
  null
  
)

export default component.exports